export default __webpack_public_path__ + "static/media/shape1.a659a395.png";